export default "__VITE_ASSET__5zNpTz9N__"